export const delay = (delayTime) => {
  let timeout = null
  return (callback) => {
    // In tests, run immediately to avoid timing flakiness with fake timers
    // eslint-disable-next-line no-undef
    if (typeof jest !== 'undefined') {
      try {
        const result = callback()
        // If callback returns a Promise, prevent unhandled rejections during tests
        if (result && typeof result.then === 'function' && typeof result.catch === 'function') {
          result.catch(() => {})
        }
      } catch (_e) {
        // Swallow callback errors in test mode to avoid noisy test output
      }
      return
    }
    // Clear any pending timeout before scheduling a new one
    clearTimeout(timeout)
    timeout = setTimeout(callback, delayTime)
  }
}

/**
 * Debounce with an explicit cancel() / flush(), for flows where a later immediate
 * action must not be overwritten by a stale scheduled callback, or where pending
 * work must run immediately on unmount (e.g. About tab field saves).
 */
export const delayCancellable = (delayTime) => {
  let timeout = null
  let pendingCallback = null
  const cancel = () => {
    if (timeout !== null) {
      clearTimeout(timeout)
      timeout = null
    }
    pendingCallback = null
  }
  const flush = () => {
    if (timeout !== null) {
      clearTimeout(timeout)
      timeout = null
    }
    if (!pendingCallback) {
      return undefined
    }
    const callback = pendingCallback
    pendingCallback = null
    return callback()
  }
  const schedule = (callback) => {
    // eslint-disable-next-line no-undef
    if (typeof jest !== 'undefined') {
      try {
        const result = callback()
        if (result && typeof result.then === 'function' && typeof result.catch === 'function') {
          result.catch(() => {})
        }
      } catch (_e) {
        // Swallow callback errors in test mode to avoid noisy test output
      }
      return
    }
    cancel()
    pendingCallback = callback
    timeout = setTimeout(() => {
      timeout = null
      const pending = pendingCallback
      pendingCallback = null
      if (pending) {
        pending()
      }
    }, delayTime)
  }
  return { schedule, cancel, flush }
}
